import React from "react";
import { Link } from "react-router-dom";
import Bg from "../../../images/shapes/shape_title_under_line.svg";
// import shape1 from "../../../images/shapes/shape_line_7.svg";
// import shape2 from "../../../images/shapes/shape_angle_4.webp";
import industryImg1 from "../../../images/blog/insurance.webp";
import industryImg2 from "../../../images/blog/banking.webp";
import industryImg3 from "../../../images/blog/fintech.webp";
import industryImg4 from "../../../images/blog/logistic.webp";
import industryImg5 from "../../../images/blog/retail.webp";
import industryImg6 from "../../../images/blog/healthcare.webp";


const BlogSection = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const industries = [
    { 
        title: "Insurance", 
        image: industryImg1, 
        link: "/industries/insurance",
        description: "Enhancing risk management with innovative digital solutions for the insurance sector."
    },
    { 
        title: "Banking", 
        image: industryImg2, 
        link: "/industries/banking",
        description: "Transforming banking experiences with secure and scalable financial solutions."
    },
    { 
        title: "Fintech", 
        image: industryImg3, 
        link: "/industries/fintech",
        description: "Revolutionizing finance with cutting-edge fintech applications and payment systems."
    },
    { 
        title: "Logistics", 
        image: industryImg4, 
        link: "/industries/logistics",
        description: "Optimizing supply chain management with smart logistics and tracking solutions."
    },
    { 
        title: "Retail", 
        image: industryImg5, 
        link: "/industries/retail",
        description: "Driving digital transformation in retail with e-commerce and inventory management."
    },
    { 
        title: "Healthcare", 
        image: industryImg6, 
        link: "/industries/healthcare",
        description: "Improving patient care with advanced healthcare technology and data solutions."
    }
];

  return (
    <section className="industries_section section_space position-relative">
      <div className="container">
        {/* Header */}
        <div className="heading_block text-center">
          <div
            className="heading_focus_text has_underline d-inline-flex"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            Our Industries
          </div>
          <h2 className="heading_text mb-4">
            Empowering <mark>Industries</mark>
          </h2>
        </div>

        {/* Industries Grid */}
        <div className="row justify-content-center">
  {industries.map((industry, index) => (
    <div
      className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch"
      key={index}
    >
      <div className="industry_block card h-100 shadow-sm border-0 d-flex flex-column">
        {/* Image Container */}
        <div className="industry_image" style={{ height: "200px", overflow: "hidden" }}>
          <Link
            onClick={ClickHandler}
            to={industry.link}
            className="image_wrap d-block"
          >
            <img
              src={industry.image}
              alt={industry.title}
              className="w-100 h-100"
              style={{ objectFit: "cover" }} // Fixes inconsistent heights
            />
          </Link>
        </div>

        {/* Content Section */}
        <div className="industry_content p-3 text-center flex-grow-1">
          <h4 className="industry_title mb-0">
            <Link
              onClick={ClickHandler}
              to={industry.link}
              className="text-dark text-decoration-none"
            >
              {industry.title}
            </Link>
          </h4>
          <p className="mt-3">{industry.description}</p>
        </div>
      </div>
    </div>
  ))}
</div>

      </div>
    </section>
  );
};

export default BlogSection;
